import React from 'react';
import { Box, IconButton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { OuterLinkIcon } from '@uplift/icons';


const useStyles = makeStyles()({
  lastWordSection: {
    whiteSpace: 'nowrap'
  },
  iconButton: {
    marginLeft: '.5rem',
    marginTop: '-2px',
  },
  icon: {
    fontSize: '14px',
  },
});


export type ExternalLinkProps = {
  to: string;
  text: string;
  fontWeight?: number;
};


export const ExternalLink: React.VFC<ExternalLinkProps> = ({ to, text, fontWeight = 500 }) => {
  const { classes } = useStyles();

  const [ firstPart, lastWord ] = React.useMemo(() => {
    const splitted = text.split(' ');

    return [ splitted.slice(0, -1).join(' '), splitted.slice(-1)[0] ];
  }, [ text ]);

  return (
    <Box component="span">
      <Box fontWeight={fontWeight} component="span">
        <span>{firstPart}</span> <span className={classes.lastWordSection}>
          {lastWord}
          <IconButton
            color="secondary"
            disableRipple
            size="small"
            component="a"
            href={to}
            target="_blank"
            rel="noopener"
            className={classes.iconButton}
          >
            <OuterLinkIcon color="secondary" className={classes.icon} />
          </IconButton>
        </span>
      </Box>
    </Box>
  );
};
